import { axiosInstanceV1, withToken } from "@bn/api";
import { UserAuthorization } from "@bn/api/apiv1";

export const getMyAuthorization = async (token: string | undefined) => {
  const { data } = await axiosInstanceV1.get<UserAuthorization>(
    `/authorizations`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const getMyAuthorizationWithToken = withToken(getMyAuthorization);
